module.exports = __webpack_public_path__ + "img/dl6.67659228.png";